import {AuthorizationError} from '../Utilities/Errors/AuthorizationError';

export namespace AuthAPI {
  export async function getUsername() {
    let url = "/api/auth/username";
    let response = await fetch(url);
    if (response.ok) {
      return await response.text();
    } else {
      return undefined;
    }
  }
}